import Image from "next/image";
import styles from "./ContactInformation.module.css";

interface Data {
  title: string;
  contact_list_with_image: Card[];
}

interface Card {
  id: number;
  items: cardsItems[];
  image: {
    id: number;
    url: string;
  };
}

interface cardsItems {
  id: number;
  item: string;
}

interface ContactInformationProps {
  data: Data;
}

const ContactInformation: React.FC<ContactInformationProps> = ({ data }) => {
  return (
    <div className={`container ${styles.outerContainer}`}>
      <h2>{data?.title}</h2>
      <div className={styles.innerContainer}>
        {data?.contact_list_with_image?.map((card) => (
          <div key={card?.id} className={styles.card}>
            <Image
              src={card?.image?.url}
              alt="map"
              title="map"
              className={styles.image}
              width={58}
              height={52}
            />
            {card?.items.map((item) => (
              <span key={item?.id}>{item?.item}</span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactInformation;
